import { render, staticRenderFns } from "./cabinet-profile.vue?vue&type=template&id=30226763&scoped=true&"
import script from "./cabinet-profile.vue?vue&type=script&lang=js&"
export * from "./cabinet-profile.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-profile.vue?vue&type=style&index=0&id=30226763&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30226763",
  null
  
)

export default component.exports